import authHeader from "../../../authentication/authservices/auth-header";
import apiClient from "../../../http-common";

//vacant Beds
export const saveChangedPassword = (finalObj) => {
  return apiClient.post(`/userManagement/changePassword`, finalObj, {
    headers: authHeader(),
  });
};
